import { render } from "./HeaderPricing.vue?vue&type=template&id=a0b9ef5a&scoped=true"
import script from "./HeaderPricing.vue?vue&type=script&lang=js"
export * from "./HeaderPricing.vue?vue&type=script&lang=js"

import "./HeaderPricing.vue?vue&type=style&index=0&id=a0b9ef5a&scoped=true&lang=css"

import exportComponent from "/home/runner/work/landing/landing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0b9ef5a"]])

export default __exports__